import styled from '@emotion/styled'

import Divider from '@segment/matcha/components/Divider'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

const DividerSection = () => {
  return (
    <StyledSectionBase variant="noCopy">
      <Section.Contents>
        <StyledDivider />
      </Section.Contents>
    </StyledSectionBase>
  )
}

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    padding-top: 0;
    padding-bottom: 0;
  }
`

const StyledDivider = styled(Divider)`
  margin-top: 0;
  margin-bottom: 0;
`

export default DividerSection
